<template>
  <div class="d-flex gap-1">
    <label :for="id" class="font-weight-bold font-size-12">{{ label }}</label>

    <div class="custom-control custom-switch custom-switch-text custom-control-inline custom-switch-color mr-0">
      <div class="custom-switch-inner">
        <input
            type="checkbox"
            class="custom-control-input bg-info"
            :id="id"
            :name="name"
            :disabled="disabled"
            :checked="isChecked"
            @change="toggle"
        >

        <label class="custom-control-label" :for="id"></label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    name: String,
    id: String,
    disabled: Boolean,

    value: {
      default: false
    },

    trueValue: {
      default: true
    },

    falseValue: {
      default: false
    }
  },

  computed: {
    isChecked () {
      return this.value === this.trueValue ||
          this.value === true ||
          this.value === 1
    }
  },

  methods: {
    toggle(e) {
      const val = e.target.checked ? this.trueValue : this.falseValue
      this.$emit('input', val)
    }
  }
}
</script>